<template>
  <div class="overlay" :class="{ visible: internalVisible, shown }">
    <div class="dialog">
      <h3 class="title">Independent Contractor Agreement</h3>
      <div class="content" :class="{ esign }">
        <iframe
          ref="iframe"
          class="iframe-body"
          frameborder="0"
          width="100%"
          height="100%"
          src="/game-content/day1/email/agreement.html"
          @load="onIframeLoad"
        ></iframe>
        <div ref="esignContainer" class="e-sign-area">
          <div class="hint">SIGN HERE</div>
          <canvas ref="canvas" class="canvas"></canvas>
        </div>
      </div>
      <div class="buttons-container" v-if="!esign">
        <button
          class="accept-button"
          :disabled="buttonDiabled"
          @click="onAccept(true)"
        >
          I have totally read the entire Agreement
        </button>
      </div>
      <div class="buttons-container" v-else>
        <button class="clear-button" @click="onClearClick(true)">
          Clear
        </button>
        <button class="accept-button" @click="onAccept(true)">
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script>
let ctx;

function setUpCanvasDrawing(canvas) {
  ctx = canvas.getContext("2d");

  let isDrawing = false;
  let lastX = 0;
  let lastY = 0;

  function draw(e) {
    if (!isDrawing) return;

    ctx.beginPath();

    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.lineWidth = 10;
    ctx.strokeStyle = "#000";

    ctx.moveTo(lastX, lastY);
    ctx.lineTo(e.offsetX, e.offsetY);
    ctx.stroke();

    lastX = e.offsetX;
    lastY = e.offsetY;
  }

  canvas.addEventListener("mousedown", e => {
    isDrawing = true;
    lastX = e.offsetX;
    lastY = e.offsetY;
  });

  canvas.addEventListener("mousemove", draw);
  canvas.addEventListener("mouseup", () => {
    isDrawing = false;
  });
  canvas.addEventListener("mouseout", () => {
    isDrawing = false;
  });
}

export default {
  name: "ULADialog",
  props: {
    visible: Boolean,
  },
  data() {
    return {
      internalVisible: this.visible,
      shown: this.visible,
      buttonDiabled: true,
      esign: false,
    };
  },
  methods: {
    onClearClick() {
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    },
    onIframeLoad() {
      const iframe = this.$refs.iframe;
      const iframeDocument = this.$refs.iframe.contentWindow.document;
      const iframeBody = iframeDocument.body;

      iframeDocument.addEventListener("scroll", () => {
        if (
          iframeBody.scrollHeight - iframeBody.scrollTop ===
          iframeBody.clientHeight
        ) {
          this.buttonDiabled = false;
        }
      });
    },
    onAccept(accept) {
      if (!this.esign) {
        this.esign = true;
      } else {
        this.internalVisible = false;

        setTimeout(() => {
          this.shown = false;
          this.$emit("accept", accept);

          this.$nextTick(() => this.syncVisible(this.visible));
        }, 250);
      }
    },
    syncVisible(value) {
      if (value) {
        this.shown = true;
        setTimeout(() => {
          this.internalVisible = true;
        }, 50);
      } else {
        this.internalVisible = false;
        setTimeout(() => {
          this.shown = false;
        }, 250);
      }
    },
  },
  watch: {
    visible(value) {
      this.syncVisible(value);
    },
  },
  mounted() {
    const canvas = this.$refs.canvas;
    const resizeObserver = new ResizeObserver(() => {
      canvas.width = this.$refs.esignContainer.clientWidth;
      canvas.height = this.$refs.esignContainer.clientHeight;
    });

    resizeObserver.observe(this.$refs.esignContainer);

    setUpCanvasDrawing(this.$refs.canvas);
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables";

.overlay {
  background-color: rgba(black, 0.5);

  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 10;

  display: none;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;

  transition-property: opacity;
  transition-duration: 250ms;
  transition-timing-function: ease-in-out;

  opacity: 0;

  &.shown {
    display: flex;
  }

  &.visible {
    opacity: 1;

    .dialog {
      transform: none;
    }
  }

  .dialog {
    flex: 1;

    margin: 32px;
    padding: 16px;

    border-radius: 6px;

    background-color: white;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);

    transition-property: transform;
    transition-duration: 250ms;
    transition-timing-function: ease-in-out;

    transform: scale(0);

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .title {
      color: $primary-text-black;
    }

    .content {
      position: relative;
      flex: 1;
      width: 100%;

      overflow: hidden;

      &.esign {
        .iframe-body {
          transform: translateX(-100%);
        }

        .e-sign-area {
          transform: none;
        }
      }

      .iframe-body {
        width: 100%;
        height: 100%;
        background-color: white;

        transition-property: transform;
        transition-duration: 250ms;
        transition-timing-function: ease-in-out;
      }

      .e-sign-area {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        z-index: 9999999;

        transform: translateX(100%);

        transition-property: transform;
        transition-duration: 250ms;
        transition-timing-function: ease-in-out;

        .hint {
          height: 100%;
          width: 100%;

          background: #eee;

          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          font-size: 3rem;

          pointer-events: none;
        }

        .canvas {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;

          z-index: 9999999;
        }
      }
    }

    .buttons-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      margin-top: 16px;

      width: 100%;

      button {
        background: none;
        border: none;
        padding: 0px;
        color: $primary-text-white;
        user-select: none;
        cursor: pointer;
      }

      .clear-button {
        background-color: lightgray;
        text-transform: uppercase;
        padding: 16px;
        width: 100%;
        border-radius: 6px;

        transition-property: background-color;
        transition-duration: 100ms;
        transition-timing-function: ease-in-out;

        font-size: 1rem;

        margin-right: 8px;

        &:hover {
          background-color: mix(lightgray, black, 90%);
        }

        &:active {
          background-color: mix(lightgray, black, 80%);
        }

        &:disabled {
          opacity: 0.5;
        }
      }

      .accept-button {
        background-color: #00c853;
        text-transform: uppercase;
        padding: 16px;
        width: 100%;
        border-radius: 6px;

        transition-property: background-color;
        transition-duration: 100ms;
        transition-timing-function: ease-in-out;

        font-size: 1rem;

        margin-left: 8px;

        &:hover {
          background-color: mix(#00c853, black, 90%);
        }

        &:active {
          background-color: mix(#00c853, black, 80%);
        }

        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
